class AggregatedAwardEntry {
  advertisers = [];
  
  brands = [];

  agencies = [];

  agencyNetworks = [];

  holdingCompanies = [];

  regions = [];

  countries = [];

  cities = [];

  years = [];

  campaigns = [];

  externalUrls = [];

  internalUrls = [];

  constructor(data) {
    this.advertisers = data.advertisers;
    this.brands = data.brands;
    this.agencies = data.agencies;
    this.agencyNetworks = data.agencyNetworks;
    this.holdingCompanies = data.holdingCompanies;
    this.regions = data.regions;
    this.countries = data.countries;
    this.cities = data.cities;
    this.years = data.years;
    this.campaigns = data.campaigns;
    this.externalUrls = data.externalUrls;
    this.internalUrls = data.internalUrls;
  }

  get assets() {
    return [...this.internalUrls, ...this.externalUrls];
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }
    
    return new AggregatedAwardEntry(data);
  }
}

export default AggregatedAwardEntry;
